<template>
  <div class="stores-Add">
    <el-form ref="form" :model="form" :rules="rules" label-width="110px">
      <el-form-item label="门店名称：" prop="shopName">
        <el-input v-model="form.shopName"></el-input>
      </el-form-item>
      <el-form-item label="门店地址：" prop="shopAddress">
        <el-input v-model="form.shopAddress" @focus="visible = true"></el-input>
      </el-form-item>
      <el-form-item label="门店电话：" prop="shopPhone">
        <el-input v-model="form.shopPhone"></el-input>
      </el-form-item>
      <el-form-item label="门店二维码：" class="uploadImg">
        <upload
          :url="form.shopQrCode"
          @successUpload="handleSuccessUpload"
          prompt="上传封面图片：大小不超过2M，支持Jpeg、Jpg、Png格式，建议上传300*300尺寸。"
        />
      </el-form-item>
      <searchInput @changeSelect="changeSelect"/>
      <el-form-item class="submit">
        <el-button type="primary" :loading="loading" @click="onSubmit('form')">保存</el-button>
        <el-button @click="$router.push({name:'StoreList'})">取消</el-button>
      </el-form-item>
    </el-form>
    <Map :visible="visible" @close="handleClose" @confirm="handleConfirm"/>
  </div>
</template>
<script>
import { addShop } from '@/api/stores';
import Upload from '@/components/Upload/index.vue';
import Map from '@/components/Map';
import searchInput from '@/components/searchInput';
import { validPhone, validLandline } from '@/utils/validate';

export default {
  data() {
    const validatePhone = (rule, value, callback) => {
      if (!value) {
        callback(new Error('手机号不能为空'));
      } else if (validPhone(value) || validLandline(value)) {
        callback();
      }
      callback(new Error('电话格式错误！'));
    };
    return {
      visible: false,
      loading: false,
      selectLoading: false,
      form: {
        shopName: '',
        shopAddress: '',
        shopLat: '',
        shopLong: '',
        shopPhone: '',
        shopQrCode: '',
        userIds: [],
      },

      rules: {
        shopName: [
          { required: true, message: '请输入门店名称', trigger: 'blur' },
        ],
        shopAddress: [
          { required: true, message: '请输入门店地址', trigger: 'change' },
        ],
        shopPhone: [
          { validator: validatePhone, trigger: 'blur' },
          { required: true, message: '请输入门店电话', trigger: 'blur' },
        ],
        userIds: [
          { required: true, message: '请选择门店店员', trigger: 'change' },
        ],
      },
    };
  },
  components: {
    Upload,
    Map,
    searchInput,
  },

  methods: {
    addShop() {
      this.loading = true;
      const { userIds } = this.form;
      addShop({ ...this.form, userIds: userIds.join(',') }).then((res) => {
        if (res.success) {
          this.loading = false;
          this.$message.success('添加成功');
          this.$router.push({
            name: 'StoreList',
          });
        } else {
          this.$message.error(res.message);
        }
      });
    },
    onSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.form.shopQrCode) {
            this.$message.warning('请上传门店二维码');
          } else {
            this.addShop();
            return true;
          }
        }
        return false;
      });
    },
    changeSelect(arr) {
      this.form.userIds = arr;
    },
    handleSuccessUpload(url) {
      this.form.shopQrCode = url;
    },
    handleClose() {
      this.visible = false;
    },
    handleConfirm(objectVal) {
      const { lng, lat, addressdetail } = objectVal;
      this.form.shopLong = lng;
      this.form.shopLat = lat;
      this.form.shopAddress = addressdetail;
      this.visible = false;
    },
  },
};
</script>
<style lang="stylus" scoped>
@import '~assets/css/mixins'
.stores-Add
  margin-top 70px
  .el-form
    width 700px
    margin 0 auto
    .uploadImg
      flex-row()
      >>>.el-form-item__content
        margin-left 0 !important
    .submit
      margin-top 55px
      text-align center
</style>
